import { USAGE_PRESETS, presetRange, rangeProblem, todayUtc } from "../../helpers/usageRange";

// value: { preset, startDate, endDate }. Same choices as the customer dashboard.
const UsageRangeFilter = ({ value, onChange }) => {
  const { preset, startDate, endDate } = value;
  const problem = preset === "custom" ? rangeProblem(value) : "";

  const pick = (next) =>
    onChange(
      next === "custom"
        ? { preset: next, startDate, endDate }
        : { preset: next, ...presetRange(next) }
    );

  return (
    <div className="usage-range">
      <div className="segmented" role="group" aria-label="Usage period">
        {USAGE_PRESETS.map(({ value: val, label }) => (
          <button
            key={val}
            type="button"
            className={`segmented-item ${preset === val ? "segmented-item-active" : ""}`}
            aria-pressed={preset === val}
            onClick={() => pick(val)}
          >
            {label}
          </button>
        ))}
      </div>
      {preset === "custom" && (
        <div className="usage-range-custom">
          <label>
            From
            <input
              type="date"
              className="form-control primary-form-control"
              value={startDate}
              max={endDate || todayUtc()}
              onChange={(e) => onChange({ ...value, startDate: e.target.value })}
            />
          </label>
          <label>
            To
            <input
              type="date"
              className="form-control primary-form-control"
              value={endDate}
              min={startDate}
              max={todayUtc()}
              onChange={(e) => onChange({ ...value, endDate: e.target.value })}
            />
          </label>
          {problem && <p className="usage-range-error">{problem}</p>}
        </div>
      )}
    </div>
  );
};

export default UsageRangeFilter;
